import { render, staticRenderFns } from "./CouncilConfig.vue?vue&type=template&id=79f1c4de&"
import script from "./CouncilConfig.vue?vue&type=script&lang=js&"
export * from "./CouncilConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports